import './style.css';

function getOrCreatePopupElement(popupId: string): HTMLDivElement | null {
    const mainContent = document.getElementById('main-content') || document.querySelector('.main-content');
    if (!mainContent) return null;

    let popupElement = document.getElementById(popupId) as HTMLDivElement | null;

    if (!popupElement) {
        popupElement = document.createElement('div');
        popupElement.id = popupId;
    }

    // Keep the popup at the top of the page content regardless of when it is shown.
    if (mainContent.firstElementChild !== popupElement) {
        mainContent.insertBefore(popupElement, mainContent.firstChild);
    }

    return popupElement;
}

export function makePopup(popupId: string, popupMessage: string, popupStyle: string, autoClose: boolean = false, autoCloseDuration: number = 3000): void {
    const popupElement = getOrCreatePopupElement(popupId);
    if (!popupElement) return;

    popupElement.classList.add('alert', `alert-${popupStyle}`, 'alert-dismissible', 'fade', 'show', 'm-3')
    popupElement.setAttribute('role', 'alert');
    popupElement.innerHTML = `
        ${popupMessage}
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
    `;

    if (autoClose) {
        setTimeout(() => {
            popupElement.classList.remove('show');
            popupElement.classList.add('hide');
        }, autoCloseDuration);
    }
}

export function clearPopup(popupId: string): void {
    const popupElement = document.getElementById(popupId);
    if (!popupElement) return;

    popupElement.className = '';
    popupElement.innerHTML = '';
}